export default "__VITE_ASSET__DhoFgJHG__"